export const NAME_LIST_REQUEST = 'NAME_LIST_REQUEST'
export const NAME_LIST_SUCCESS = 'NAME_LIST_SUCCESS'
export const NAME_LIST_FAIL = 'NAME_LIST_FAIL'
export const NAME_LIST_RESET = 'NAME_LIST_RESET'

export const NAME_ADD_REQUEST = 'NAME_ADD_REQUEST'
export const NAME_ADD_SUCCESS = 'NAME_ADD_SUCCESS'
export const NAME_ADD_FAIL = 'NAME_ADD_FAIL'

export const NAME_DELETE_REQUEST = 'NAME_DELETE_REQUEST'
export const NAME_DELETE_SUCCESS = 'NAME_DELETE_SUCCESS'
export const NAME_DELETE_FAIL = 'NAME_DELETE_FAIL'

export const NAME_ALL_REQUEST = 'NAME_ALL_REQUEST'
export const NAME_ALL_SUCCESS = 'NAME_ALL_SUCCESS'
export const NAME_ALL_FAIL = 'NAME_ALL_FAIL'
